import React, { useEffect, useState } from "react";
import { Grid, Box, Button, Typography } from "../../../components/ui";
import axiosInstance from "../../../axios/axiosInstance";
import { toast } from "react-toastify";
import { handeleUpdateStatus } from "../../../utils/update-request-status";

interface Prop {
  requestData?: any;
  onClose?: () => void;
  requestId?: any;
}
const DeleteApartments: React.FC<Prop> = ({
  requestData,
  onClose,
  requestId,
}) => {
  const role = localStorage.getItem("role");
  const [data, setData] = useState<any>(null);

  console.log(requestData, requestData?.id);

  const handleGetApartments = async (id: any) => {
    try {
      const resp: any = await axiosInstance.get(`/api/appartment/${id}`);
      if (resp.status === 200) {
        setData(resp?.data?.data);
      }
    } catch (Error: any) {
      toast.error(Error?.response?.data?.body);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      // When approving a request, execute directly without invocation
      const url = requestId 
        ? `/api/appartment/${requestData?.data?.id}` 
        : `/api/appartment/${requestData?.data?.id}?invocation=${role}`;
      
      const resp: any = await axiosInstance.delete(url);
      if (resp.status === 200) {
        if (requestId) {
          handeleUpdateStatus(requestId, "1");
        }
        if (requestId) {
          toast.success("Request approved and apartment deleted successfully");
        } else {
          toast.success("Apartment deleted successfully");
        }
        onClose?.();
      }
    } catch (Error: any) {
      toast.error(Error?.response?.data?.body || Error?.message);
    }
  };
  useEffect(() => {
    handleGetApartments(requestData?.data?.id);
  }, [requestData]);

  return (
    <div>
      <Grid container>
        <Grid size={12}>
          <Typography fontSize={18} fontWeight={500} color="#1F2937">
            Delete Apartment
          </Typography>
        </Grid>

        <Grid size={12} borderBottom={"1px solid #1F2937"}>
          <Typography fontSize={17} fontWeight={600} color="#1F2937">
            Apartment Details
          </Typography>
        </Grid>
        <Grid size={12}>
          <Typography fontSize={16} fontWeight={500} color="#1F2937">
            Apartment Name : {data?.appartment_name}
          </Typography>
        </Grid>
        <Grid size={12}>
          <Typography fontSize={16} fontWeight={500} color="#1F2937">
            Apartment No : {data?.appartment_no}
          </Typography>
        </Grid>

        <Grid size={12}>
          <Typography fontSize={16} fontWeight={500} color="#1F2937">
            Floor: {data?.floor}
          </Typography>
        </Grid>

        <Grid size={12} borderBottom={"1px solid #1F2937"}>
          <Typography fontSize={17} fontWeight={600} color="#1F2937">
            Apartment Type
          </Typography>
        </Grid>

        <Grid size={12} mt={1}>
          <Typography fontSize={16} fontWeight={500} color="#1F2937">
            {data?.apartment_type}
          </Typography>
        </Grid>

        <Grid size={12} borderBottom={"1px solid #1F2937"}>
          <Typography fontSize={17} fontWeight={600} color="#1F2937">
            Block
          </Typography>
        </Grid>

        <Grid size={12} mt={1}>
          <Typography fontSize={16} fontWeight={500} color="#1F2937">
            {data?.block?.block_name}
          </Typography>
        </Grid>

        <Grid size={12}>
          <Grid size={12} display={"flex"} justifyContent={"end"}>
            {" "}
            <Box display={"display"}>
              <Button
                size="small"
                variant="contained"
                sx={{ mx: 1, bgcolor: "#1F2937" }}
                onClick={handleDelete}
              >
                Delete
              </Button>

              <Button
                size="small"
                variant="outlined"
                sx={{ color: "#1F2937", borderColor: "#1F2937" }}
                onClick={onClose}
              >
                Close
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default DeleteApartments;
